import axios from 'axios'

import environment from '@/environment'
import type { BidType, MarketProgram } from '@/features/bidding/constants'

const PORTFOLIO_MANAGER_API_URL = environment.services.portfolioManagerApiUrl

export const GET_COMPLETED_BID_MARKETS_API_ID = 'GET_COMPLETED_BID_MARKETS'

export type MarketBidType = {
  marketProgram: MarketProgram
  bidType: BidType
}

export type CompletedBidMarkets = {
  deliveryDay: string
  portfolioCode: string
  resourceCategory: string
  markets: MarketBidType[]
}

export type GetCompletedBidMarketsParams = {
  deliveryDay: string
  portfolioCode: string
  resourceCategory: string
}

export const getCompletedBidMarkets = async (params: GetCompletedBidMarketsParams): Promise<CompletedBidMarkets> =>
  (
    await axios.get(`${PORTFOLIO_MANAGER_API_URL}/bid/completed-markets`, {
      params,
    })
  ).data
